'use strict';

import angular from 'angular';
import ImportController from './import.controller';

export default angular.module('updateServerApp.betagroups.import', [])
  .controller('BetaGroupsImportController', ImportController)
  .name;



// WEBPACK FOOTER //
// ./client/app/betagroups/import/index.js